import { type DatasetName } from '@autone/redux/data-ingestion';
import { type GeneralCommonPaths } from '@autone/translations';

// Map data source identifiers to translation keys
export const datasetTranslationKeyMap: Record<DatasetName, GeneralCommonPaths> =
  {
    production: 'data-age.data-sources.pending-from-production',
    warehouse: 'data-age.data-sources.warehouse',
    inventory: 'data-age.data-sources.inventory',
    sales: 'data-age.data-sources.sales',
    forecast: 'data-age.data-sources.forecast',
    solver_run: 'data-age.data-sources.solver-run',
  };
